module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper video-player-wrapper bodyfont-unauth"
  }, [(_vm.currentVideo) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "video-player autoheight"
  }, [(_vm.currentVideo && !_vm.showThumbnail) ? _c('div', {
    staticClass: "show-video-class"
  }, [_c('h2', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.currentVideo.title))]), _vm._v(" "), _c('jwplayer', {
    attrs: {
      "id": "mainVideoPlayer",
      "data": _vm.currentVideo
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e(), _vm._v(" "), (_vm.currentVideo && _vm.showThumbnail) ? _c('div', {
    staticClass: "show-video-thumbnail"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.currentVideo.title))]), _vm._v(" "), _c('img', {
    staticClass: "makeitgray ",
    attrs: {
      "src": _vm.currentVideo.img,
      "alt": _vm.currentVideo.title,
      "title": _vm.currentVideo.title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "thumbnail-messaing"
  }, [_vm._v("\n                                Want more tips?"), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/signup')
      }
    }
  }, [_vm._v(" Sign up ")]), _vm._v(" today for your free TONE trial! No credit card required!\n                            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.videoNotFoundFlag) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.currentVideo) ? _c('div', {
    staticClass: "player-content"
  }, [_c('p', {
    staticClass: "video-description"
  }, [_vm._v("\n                            " + _vm._s(_vm.currentVideo.Description) + "\n                        ")]), _vm._v(" "), (_vm.getCorpButtonColor === '#f0617d') ? _c('div', {
    staticClass: "container-icons vpage"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getCorpButtonColor !== '#f0617d') ? _c('div', {
    staticClass: "container-icons vpage"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.videoExpert) ? _c('div', {
    staticClass: "profile-content"
  }, [_c('a', {
    attrs: {
      "href": '/expert/' + _vm.videoExpert[0].expertId + '/' + _vm.videoExpert[0].name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase(),
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.videoExpert[0].small_image,
      "alt": _vm.videoExpert && _vm.videoExpert[0].name,
      "title": _vm.videoExpert && _vm.videoExpert[0].name
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.videoExpert && _vm.videoExpert[0].name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.videoExpert && _vm.videoExpert[0].experties))])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "video-text"
  }, [_vm._v("\n                            " + _vm._s(_vm.videoExpert && _vm.videoExpert[0].areasofexpertise) + "\n                        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.videoTag && _vm.videoTag !== 'COMMUNITY') ? _c('h2', [_vm._v("MORE " + _vm._s(_vm.videoTag) + " VIDEOS")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.videoList) ? _c('div', {
    staticClass: "row morevediosrow"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider largeslidesilderplayicon"
  }, _vm._l((_vm.videoList), function(vid) {
    return _c('div', {
      staticClass: "slide-player"
    }, [(_vm.videoList) ? _c('div', {}, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/contentvideos/play/' + vid.mediaid + '/' + vid.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": vid.image,
        "alt": vid.title,
        "title": vid.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(vid.title))])])]) : _vm._e()])
  }), 0)]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "errormessage"
  }, [_vm._v("This video is for Members only. "), _c('br'), _vm._v("\n                Become a member today by starting your Free Trial")])
}]}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd2b68da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/UnauthVideoPlayer.vue